var App = App || {};
App.BannerSlider = (function ($) {
    'use strict';

    var $slider = $(".banner-slider-items");

    function init() {
        $slider.slick({
            dots: true,
            appendDots: ".banner-slider-dots",
            arrows: true,
            prevArrow: ".banner-slider-controls .prev-button",
            nextArrow: ".banner-slider-controls .next-button",
            autoplay: true,
            autoplaySpeed: 5000
        });

        resizeBannerSliders();
        $(window).on("resize", function () {
            resizeBannerSliders();
        });
        $(window).on("orientationchange", function (event) {
            resizeBannerSliders();
        });

        /* Pause and play functionality */
        $('.slide-control.slick-arrow').on('click', function () {     
            if ($('.slide-control.slick-arrow').children('i').hasClass('fa-pause'))
            {
                $slider.slick('slickPause');
                $('.slide-control.slick-arrow').children('i').removeClass('fa-pause');
                $('.slide-control.slick-arrow').children('i').addClass('fa-play');
            }
            else {
                $slider.slick('slickPlay');
                $('.slide-control.slick-arrow').children('i').removeClass('fa-play');
                $('.slide-control.slick-arrow').children('i').addClass('fa-pause');
            }   
        });

        $('.slick-dots').on('keydown', function (e)
        {
            if (e.which == 38)
            {
                $('.slick-active .banner__links a').first().trigger('focus');
                $('.slick-active .banner__links a').first().addClass('button-focus');
            }
            console.log(e.which);
        })

        //Tamper to remove button focus when button was focused on other button
        $(".banner__links a").on('focus', function (event) {
            $(".btn.btn-secondary").removeClass('button-focus');
        });
        
    }

    function resizeBannerSliders() {
        var height = 0;

        $('.banner-slider-item .banner').each(function () {
            if ($(this).height() > height) {
                height = $(this).height();
            }
        });

        $('.banner-slider-item .banner').css('height', height);

    }

    function isMobileOrientation() {
        // Get the width and height of the window
        var width = $(window).width();
        var height = $(window).height();

        // Check if width is less than height (portrait mode)
        return width < height;
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.BannerSlider.init();
});